<template>
  <vs-card v-if="location" :to="linkTo">
    <div>
      <v-row dense>
        <v-col>
          <vs-text type="overline">{{ location.parentName }}</vs-text>
          <vs-heading>{{ location.location }}</vs-heading>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <div class="attribute">
            <v-icon class="icon" small>{{ location.icon }}</v-icon>
            <vs-text type="caption">
              <span class="description">{{ location.locationTypeName }}</span>
            </vs-text>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="location.locationStatusDescription" dense>
        <v-col>
          <div class="attribute">
            <v-icon class="icon" x-small :color="location.locationStatusColorHexCode"
              >mdi-circle</v-icon
            >
            <vs-text type="caption">
              <span class="description">{{ location.locationStatusDescription }}</span>
            </vs-text>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="jobCount" dense>
        <v-col>
          <vs-text>Jobs at location: {{ jobCount }} </vs-text>
        </v-col>
      </v-row>
    </div>
  </vs-card>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import VsText from '@/components/vision/VsText.vue'
import VsCard from '@/components/vision/VsCard.vue'
import { useLocationQuery } from '@/api/locations'
import type { RouterLinkProps } from 'vue-router/types/router'

type RouterLinkTo = RouterLinkProps['to']

const props = defineProps<{
  locationId: string
  jobCount?: number
  linkTo: RouterLinkTo
}>()

const locationIdRef = toRef(props, 'locationId')
const { data: location } = useLocationQuery(locationIdRef)
</script>

<style scoped>
.attribute {
  display: flex;
  align-self: center;
  justify-content: flex-start;
  column-gap: 0.4em;
}
.icon {
  flex-basis: 16px;
}
</style>
